import React from 'react';
import '../../pages/vault/vault.css';

// A hanger with an empty care label, swinging (the vault's empty state, #467):
// used where a label leads nowhere, and for an empty vault.
const EmptyHanger: React.FC<{ className?: string }> = ({ className = '' }) => (
  <svg className={`sh-hanger ${className}`} viewBox="0 0 200 150" width="180" height="135" aria-hidden="true">
    <g className="v-hanger">
      <path d="M100 18c0-6 9-6 9 0 0 5-9 6-9 13v6" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
      <path d="M100 37 34 76c-6 4-4 10 3 10h126c7 0 9-6 3-10L100 37z" fill="none" stroke="currentColor" strokeWidth="3" strokeLinejoin="round" />
      <g className="v-hanger-label">
        <path d="M84 86v16" stroke="#e07b3c" strokeWidth="1.6" />
        <rect x="70" y="102" width="28" height="36" rx="2" fill="#fbfcfa" />
        <rect x="73.5" y="105.5" width="21" height="29" rx="1" fill="none" stroke="#e07b3c" strokeWidth="1.1" strokeDasharray="3 2" />
        <path d="M77 112h7v7h-7zM88 112h5M88 117h5M77 124h16M77 130h10" stroke="#305355" strokeWidth="1.4" fill="none" />
      </g>
    </g>
  </svg>
);

export default EmptyHanger;
